import { Modal } from 'antd';
import styled from 'styled-components';
import {
  conscientiousPopup, dominantPopup, influencingPopup, midMobile, smMobile,
  steadyPopup,
} from 'Utils/utilsStyle';
import setImageSize, { getStringAfterQueryParam } from 'Utils/UtilityFunctions';
import { useRef } from 'react';
import { BOOK_A_MEETING_LINK } from 'Utils/Constants';
import CrossCircle from '../assets/svgIcons/CrossCircle';

const MarketingModal = styled(Modal)`
  cursor: pointer;
  .ant-modal-footer {
    display: none;
  }
  .ant-modal-content {
    position: relative;
    height: 477px;
    @media all and (max-width: ${midMobile}) {
      height: 350px;
    }
     @media all and (max-width: ${smMobile}) {
      height: 250px;
    }
    .img-markt-popup {
      height: 100%;
      width: 100%;
    }
  }
  .anchor-class-marketing {
    position: absolute;
    height: 100%;
    width: 100%;
  }
  .banner-heading {
    position: absolute;
    left: 66px;
    top: 99px;
    font-size: 42px;
    color: #fff;
    width: 390px;
    line-height: 48px;
    font-weight: 700;
    @media all and (max-width: ${midMobile}) {
      width: 300px;
      line-height: 40px;
      left: 47px;
      top: 90px;
      font-size: 30px;
    }
    @media all and (max-width: ${smMobile}) {
      width: 210px;
      line-height: 30px;
      left: 38px;
      top: 68px;
      font-size: 22px;
    }
  }
  .ant-modal-content {
    .ant-modal-body {
      padding: 0px 0px 0px 0px;
      padding-top: 0px !important;
      height: 100%;
    }
  }
`;

type Props = {
  setGuestBanner: () => void;
  personPersonality: string,
  loading: boolean
  text: string;
  guestBanner: boolean
};
const GuestPopup = function GuestPopup(props: Props) {
  const {
    setGuestBanner,
    personPersonality,
    loading,
    text,
    guestBanner,
  } = props;
  const elementRef = useRef<HTMLDivElement>(null);
  const getBanner = (personality: string) => {
    if (personality === 'Dominant') {
      return dominantPopup;
    } if (personality === 'Conscientious') {
      return conscientiousPopup;
    } if (personality === 'Steady') {
      return steadyPopup;
    }
    return influencingPopup;
  };

  const callToAction = () => {
    const queryString = getStringAfterQueryParam('isGuest=true');
    const meetingLink = `${BOOK_A_MEETING_LINK}${queryString ? queryString.replace('&', '?') : ''}`;
    window.open(meetingLink);
  };

  const onClickCancel = () => {
    setGuestBanner();
  };

  return (
    <div>
      {
        !loading && (
          <MarketingModal
            centered
            width={750}
            closeIcon={<div className="cross-icon-x"><CrossCircle /></div>}
            getContainer=""
            wrapClassName="marketing-popups"
            visible={guestBanner}
            onCancel={onClickCancel}
            closable
          >

            <span
              role="button"
              tabIndex={0}
              onKeyPress={() => callToAction()}
              onClick={() => callToAction()}
              className="anchor-class-marketing"
            >
              <h3 className="banner-heading">
                {text}
              </h3>
              <img
                className="img-markt-popup"
                src={setImageSize(
                  getBanner(personPersonality),
                  elementRef.current?.clientWidth || 300,
                  elementRef.current?.clientHeight || 180,
                  0,
                )}
                alt="img-marketing"
              />
            </span>
          </MarketingModal>
        )
      }
    </div>

  );
};
export default GuestPopup;
